import script from "./CoveragePageNotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./CoveragePageNotFound.vue?vue&type=script&setup=true&lang=js"

import "./CoveragePageNotFound.vue?vue&type=style&index=0&id=f22af620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f22af620"]])

export default __exports__